import { isAuth } from 'utils/configs';
import { Navigate } from 'react-router-dom';
import { ROUTES } from 'utils/routeNames';

export const withAuthentication = (Component) => {
  if (isAuth()) {
    return (
      <Navigate
        to={{
          pathname: `${ROUTES.INDEX}`,
        }}
      />
    );
  }
  return <Component />;
};
